"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgCoin = function SvgCoin(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24 12c6.617 0 12 5.383 12 12s-5.383 12-12 12-12-5.383-12-12 5.383-12 12-12zm0 1.618c-5.725 0-10.382 4.657-10.382 10.381 0 5.725 4.657 10.383 10.382 10.383s10.382-4.658 10.382-10.383c0-5.724-4.657-10.38-10.382-10.38zm0 2.623c.447 0 .809.362.809.809v1.437c.874.144 1.715.467 2.362.976a.806.806 0 01.136 1.134.806.806 0 01-1.136.136c-.944-.743-2.701-.942-3.76-.43-.61.296-.905.771-.905 1.455 0 .947.89 1.227 2.78 1.598 1.706.335 3.827.752 3.827 2.884 0 1.273-.616 2.292-1.732 2.87-.463.238-1.008.357-1.572.42v1.913a.809.809 0 11-1.619 0v-1.934c-.805-.131-1.582-.414-2.202-.854a.809.809 0 01.935-1.32c.999.707 2.698.864 3.714.336.577-.297.857-.766.857-1.432 0-.679-.66-.93-2.52-1.295-1.725-.34-4.087-.805-4.087-3.186 0-1.308.646-2.341 1.817-2.91a4.61 4.61 0 011.486-.407V17.05c0-.447.362-.81.81-.81z",
    id: "coin_svg__a"
  }));
};

var _default = SvgCoin;
exports["default"] = _default;